module.exports = __webpack_public_path__ + "e4a4c254e8faaa8e85bd7e3096be2471.pdf";